/**
 * Created by eriksundqvist on 08/11/16.
 */
class CalculatorWorkerEntity {

  constructor (
    amount,
    fee,
    tax,
    /*eslint-disable */
    payroll_tax,
    /*eslint-enable */
    allowance,
    travel,
    vacation,
    itp,
    id,
    net,
    gross
  ) {
    this.amount = amount;
    this.fee = fee;
    this.tax = tax;
    /*eslint-disable */
    this.payroll_tax = payroll_tax;
    /*eslint-enable */
    this.allowance = allowance;
    this.travel = travel;
    this.vacation = vacation;
    this.itp = itp;
    this.id = id;
    this.net = net;
    this.gross = gross;
  }
}

export default CalculatorWorkerEntity;



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/calculator/calculator-worker-entity.js
 **/